module.exports = __webpack_public_path__ + "media/images/xc_3-129d9f796c753f213ea6d43b1b27d55c.png";